module.exports = __webpack_public_path__ + "img/date.131db0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/date.png
// module id = /Bp8
// module chunks = 15